import { observable, computed } from 'mobx';
import { cities, pointOfInterests, bodiesOfWater } from '../data/data.js';

class UIStore {
    @observable showSidebar = false;
    @observable selectedCity = null;
    @observable selectedType = 'all'
    @observable likedPoints = [];

    set showSidebar(show) {
        this.showSidebar = show;
    }

    set selectedCity(city) {
        this.selectedCity = city;
    }

    set selectedType(type) {
        this.selectedType = type;
    }

    set likedPoints(likedPoints) {
        this.likedPoints = likedPoints;
    }

    @computed get getMarkerData() {
        let markerData = [...pointOfInterests, ...cities, ...bodiesOfWater];

        if (this.selectedType !== 'all') {
            markerData = markerData.filter((point) => this.selectedType === point.type);
        }

        return markerData;
    }

    getType() {
        if (!this.selectedCity) {
            return null;
        }

        return this.selectedCity.type;
    }

    isFavorited(point) {
        const favorited = this.likedPoints.find((liked) => liked.id === point.id);
        return favorited;
    }

    updateLikedPoints() {
        let likedPoints = this.likedPoints;

        // if point found, remove from array
        const pointFound = likedPoints.find((point) => point.id === this.selectedCity.id);
        if (pointFound) {
            likedPoints = likedPoints.filter((point) => point.id !== this.selectedCity.id);
        } else {
            likedPoints.push({ id: this.selectedCity.id });
        }

        // set to UIStore and localStorage
        localStorage.setItem('likedPoints', JSON.stringify(likedPoints));
        this.likedPoints = likedPoints;
    }
}

export default new UIStore();
